import HomePage from "@/page/homepage/HomePage";

export default [
    {
        name: "homePage",
        path: "/",
        component: HomePage
    },
]
